import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetchVisitTasks from '../../../hooks/visit/tasks/useFetchVisitTasks';
import { setSelectedVisitTaskAction } from '../../../redux/actions/visitTasksActions';
import Price from '../../shared/price/Price';
import EmptyContent from '../../shared/table/EmptyContent';
import VisitTasksTable from './VisitTasksTable';
import DeleteVisitTaskModal from './modals/DeleteVisitTaskModal';
import UpdateVisitTaskModal from './modals/UpdateVisitTaskModal';

const VisitTasksList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const totalPrice = useSelector((state) => state.visitTasks?.totalPrice);
  const { loading, visitTasks, refresh } = useFetchVisitTasks(vin, id);

  const [showUpdateVisitTaskModal, setShowUpdateVisitTaskModal] = useState(false);
  const [showDeleteVisitTaskModal, setShowDeleteVisitTaskModal] = useState(false);

  const handleVisitTaskClick = (visitTask) => {
    dispatch(setSelectedVisitTaskAction(visitTask));
    setShowUpdateVisitTaskModal(true);
  };

  const handleUpdateVisitTaskModalSubmit = async () => {
    refresh();
    setShowUpdateVisitTaskModal(false);
  };

  const handleVisitTaskDeleteClick = (visitTask) => {
    dispatch(setSelectedVisitTaskAction(visitTask));
    setShowDeleteVisitTaskModal(true);
  };

  const handleDeleteVisitTaskModalSubmit = async () => {
    refresh();
    setShowDeleteVisitTaskModal(false);
  };

  return (
    <div className="flex flex-col items-center">
      {showUpdateVisitTaskModal && (
        <UpdateVisitTaskModal
          readOnly={readOnly}
          onModalSubmit={() => handleUpdateVisitTaskModalSubmit()}
          onModalClose={() => setShowUpdateVisitTaskModal(false)}
        />
      )}
      {showDeleteVisitTaskModal && (
        <DeleteVisitTaskModal
          onModalSubmit={() => handleDeleteVisitTaskModalSubmit()}
          onModalClose={() => setShowDeleteVisitTaskModal(false)}
        />
      )}
      <VisitTasksTable
        onVisitTaskClick={handleVisitTaskClick}
        onVisitTaskDeleteClick={handleVisitTaskDeleteClick}
        visitTasks={visitTasks}
        readOnly={readOnly}
        loading={loading}
      />
      {visitTasks.length === 0 ? (
        <EmptyContent title={'Список послуг візиту порожній'} />
      ) : (
        <Price price={totalPrice} />
      )}
    </div>
  );
};

export default memo(VisitTasksList);
